import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#111827'
  }} data-id="element-313">
      <div className="max-w-4xl mx-auto" data-id="element-314">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-315">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-316" />

          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-16" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-317">
            Ce que disent les mamans
          </h2>

          <div className="space-y-6 md:space-y-12" data-id="element-318">
            {/* Testimonial 1 */}
            <div className="p-6 md:p-8 rounded-2xl" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-319">
              <div className="flex gap-1 mb-4 text-amber-500" data-id="element-320">⭐⭐⭐⭐⭐</div>
              <p className="text-lg md:text-xl italic mb-6" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#C8C0B0'
            }} data-id="element-321">
                "J'ai appliqué le Brain Dump le premier soir. J'ai dormi sans me
                réveiller à 3h du matin pour la première fois depuis des mois.
                10 minutes. C'est tout."
              </p>
              <div className="font-medium" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#D4A853'
            }} data-id="element-322">
                — Julie M., maman de 2 enfants
                <span className="block text-sm opacity-70 mt-1" data-id="element-323">
                  Montréal, Québec
                </span>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="p-6 md:p-8 rounded-2xl" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-324">
              <div className="flex gap-1 mb-4 text-amber-500" data-id="element-325">⭐⭐⭐⭐⭐</div>
              <p className="text-lg md:text-xl italic mb-6" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#C8C0B0'
            }} data-id="element-326">
                "Le dimanche soir, j'angoissais tellement que j'en pleurais
                parfois. Maintenant j'ouvre mon dashboard, 15 minutes, et je
                regarde ma série sereine. Mon chum me demande ce que j'ai
                changé."
              </p>
              <div className="font-medium" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#D4A853'
            }} data-id="element-327">
                — Sandrine L., maman solo
                <span className="block text-sm opacity-70 mt-1" data-id="element-328">
                  Lyon, France
                </span>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="p-6 md:p-8 rounded-2xl" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-329">
              <div className="flex gap-1 mb-4 text-amber-500" data-id="element-330">⭐⭐⭐⭐⭐</div>
              <p className="text-lg md:text-xl italic mb-6" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#C8C0B0'
            }} data-id="element-331">
                "J'étais sceptique. 9,97 $, c'est quoi ça peut vraiment changer
                ? Ça a changé mes soirées. Ça a changé mes matins. Ça a changé
                ma patience avec mes enfants. J'aurais payé 10x plus."
              </p>
              <div className="font-medium" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#D4A853'
            }} data-id="element-332">
                — Karine D., infirmière, maman de 3 enfants
                <span className="block text-sm opacity-70 mt-1" data-id="element-333">
                  Québec City
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}